import { useCallback } from 'react'
import { graphql, useMutation } from 'react-relay'

import {
  type useSetUserAcceptableUseAgreedMutation as UseSetUserAcceptableUseAgreedMutation,
  type useSetUserAcceptableUseAgreedMutation$data
} from '@/__generated__/useSetUserAcceptableUseAgreedMutation.graphql'

type CommitAsyncFn = () => Promise<useSetUserAcceptableUseAgreedMutation$data>

export const useSetUserAcceptableUseAgreedMutation = (): [CommitAsyncFn, boolean] => {
  const [commit, isPending] = useMutation<UseSetUserAcceptableUseAgreedMutation>(graphql`
    mutation useSetUserAcceptableUseAgreedMutation($input: SetUserAcceptableUseAgreedInput!) {
      setUserAcceptableUseAgreed(input: $input) {
        clientMutationId
        user {
          acceptableUseAgreedAt
          updatedAt
        }
      }
    }
  `)

  const commitAsync = useCallback<CommitAsyncFn>(
    () =>
      new Promise<useSetUserAcceptableUseAgreedMutation$data>((resolve, reject) =>
        commit({
          onCompleted: (response, errors) => {
            if (errors) {
              reject(errors)
            } else {
              resolve(response)
            }
          },
          // transport-level failures (offline, 5xx, WS drop) invoke onError, not onCompleted — without
          // this the promise would never settle and the caller would hang forever.
          onError: (error) => reject(error),
          variables: {
            input: {
              clientMutationId: 'setUserAcceptableUseAgreed'
            }
          }
        })
      ),
    [commit]
  )

  return [commitAsync, isPending]
}
